<app-any-notes-page
  [objectType]="objectType"
  [objectId]="objectId"
  [filter]="filter"
  [extraFields]="extraFields"></app-any-notes-page>

